(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningUserProfileController', WarningUserProfileController);

    WarningUserProfileController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'UserProfile', '$state', '$uibModalInstance', 'Warning'];

    function WarningUserProfileController($timeout, $scope, $stateParams, entity, UserProfile, $state, $uibModalInstance, Warning) {
        var vm = this;
        vm.warning = entity;
        vm.userProfiles = UserProfile.alertsProfile();
        vm.profile = vm.warning.userProfile;

        vm.clear = function() {
            $uibModalInstance.close();
        };

        vm.update = function () {
            vm.warning.userProfile  = vm.profile;
            Warning.update(vm.warning);
            vm.clear();
        };
    }
})();
